import {classNames} from '@cohort/shared-frontend/utils/classNames';
import type {BaseButtonProps} from '@cohort/wallet/components/button/BaseButton';
import {BaseButton} from '@cohort/wallet/components/button/BaseButton';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';

type SecondaryButtonProps = BaseButtonProps;

const SecondaryButton: React.FC<SecondaryButtonProps> = ({className, ...props}): JSX.Element => {
  const {hasDarkBg} = useThemeContext();
  const {disabled} = props;

  return (
    <BaseButton
      className={classNames(
        hasDarkBg ? 'bg-white/8' : 'bg-black/4',
        !disabled && hasDarkBg && 'hover:bg-white/4',
        !disabled && !hasDarkBg && 'hover:bg-black/8',
        className
      )}
      {...props}
    />
  );
};

export default SecondaryButton;
